﻿export class BackMultiSelect extends kendo.ui.MultiSelect {
    listView: IMultiSelectListView;
}

window.BackMultiSelect = BackMultiSelect;
